import i18n = require("i18next");

import { LoginViewModelBase } from './LoginViewModelBase';

$(() => {
    ko.applyBindings(new SmartManager.RelayLoginViewModel(), document.getElementById('login_wrapper'));

    var css = require("../../styles/style.scss");
    var style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = css;

    document.body.appendChild(style);
});

module SmartManager {
    export class RelayLoginViewModel extends LoginViewModelBase {
        public RelayId = ko.observable('');

        public Headline = ko.observable('Welcome to');
        public Description = ko.observable('Login here to access your evonHOME from everywhere.');
        public LoginText = ko.observable('Login');
        public DemoText = ko.observable('this way to the DEMO');
        public VersionInfoText = ko.observable('');

        public Languages = ko.observableArray([
            {
                "key": "de",
                "value": "Deutsch"
            },
            {
                "key": "en",
                "value": "English"
            },
            {
                "key": "nl",
                "value": "Nederlands, Vlaams"
            }
        ]);
        public CurrentLang = ko.observable('en');
        private LanguageChanged = false;
        private LanguageCacheKey = "prefered_browser_language";
        constructor() {
            super();
            
            this.CurrentLang(this.getUserLang());
            this.RefreshLanguage();
            this.CurrentLang.subscribe(() => {
                this.LanguageChanged = true;
                this.setLocalValue(this.LanguageCacheKey, this.CurrentLang());
                this.RefreshLanguage();
            });

            let query = window.location.search.substr(1);
            let vars = query.split('&');
            for (let v of vars) {
                if (v.indexOf("relayid=") != 0)
                    break;

                let relayid = v.split("=")[1];
                if (relayid != null && relayid != "")
                    this.RelayId(relayid);
            }
        }

        /**
         * Initiates or refreshes language with current language setting
         */
        private RefreshLanguage(): void {
            i18n.init({
                lng: this.CurrentLang(),
                resources: {
                    en: {
                        translation: require('json!../../content/locales/en/translation.json')
                    },
                    de: {
                        translation: require('json!../../content/locales/de/translation.json')
                    }
                }
            }, (err) => {
                this.WrongCredentialsText = i18n.t('wrong_credentials');
                this.LoginErrorText = i18n.t('login_error');

                this.Headline(i18n.t('page_relaylogin.headline'));
                this.Description(i18n.t('page_relaylogin.description'));
                this.LoginText(i18n.t('common.login'));
                this.DemoText(i18n.t('page_relaylogin.demolink'));
                this.VersionInfoText(i18n.t('page_relaylogin.redirect_text'));
            });
        }
        
        /**
         * Starts login process with passed relayid and language parameters
         */
        public Login(): void {
            var data: ObjectMap<string> = {
                relayid: this.RelayId()
            }

            if (this.LanguageChanged) {
                data['language'] = this.CurrentLang();
            }

            this.LoginInternal(data);
        }

        /**
         * Redirects client to target relay engine with passed language setting and stores language on client
         * @param {string} lang target language setting
         */
        public LoginSuccess(lang: string): void {
            this.setLocalValue(this.LanguageCacheKey, lang);
            if (lang != null && lang.length == 2) {
                window.location.href = "/" + this.RelayId() + "/" + lang + "/";
            }
            else {
                window.location.href = "/" + this.RelayId() + "/";
            }
        }

        /**
         * Handles login errors
         */
        public LoginError(): void {

        }

        /**
         * Gets stored user language or if not found browser language
         * @returns {string} user language code
         */
        public getUserLang(): string {
            var savedLanguage = this.getLocalValue(this.LanguageCacheKey);
            if (savedLanguage != null && savedLanguage != "") {
                //saved language found;
                return savedLanguage;
            }
            else {
                //no saved language found -> taking client language
                var userLang = navigator.language || (<any>navigator).userLanguage;
                var i = userLang.indexOf('-');
                if (i != -1) {
                    userLang = userLang.substr(0, userLang.indexOf('-'));
                }
                if (this.Languages().filter(c => c.key == userLang).length == 0) {
                    userLang = "en";
                }
                return userLang;
            }
        }

        /**
         * Get LocalStorage Key/Value
         * @param {string} key LocalStorage Key
         */
        public getLocalValue(key: string): string {
            return localStorage.getItem(key);
        }

        /**
         * Set LocalStorage Key/Value
         * @param {string} key LocalStorage Key
         * @param {string} value LocalStorage Value
         */
        public setLocalValue(key: string, value: string): void {
            localStorage.setItem(key, value);
        }

        /**
         * Get cookie value from client 
         * @param {string} name cookie key
         * @returns {string} cookie value
         */
        public getCookie(name:string): string {
            var clientCookieString: Array<string> = document.cookie.split('; ');
            var parsedCookies: ObjectMap<string> = {};
            for (var i = clientCookieString.length - 1; i >= 0; i--) {
                var singleCookie:Array<string> = clientCookieString[i].split('=');
                parsedCookies[singleCookie[0]] = singleCookie[1];
            }

            return parsedCookies[name];
        }
        
        /**
         * Set cookie
         * @param {string} name cookie key
         * @param {string} value cookie value
         */
        public setCookie(name: string, value: string): void {
            document.cookie = name + '=' + value;
        }
    }
}

interface ObjectMap<T> {
    [key: string]: T;
}


// WEBPACK FOOTER //
// ./src/Client/login.ts